import type { ChamferShapeBuildInput } from '../types/ChamferShapeBuildInput';

/**
 * 倒角 Shape 求解器基类。
 */
export abstract class ChamferSolver {
  /** 当前 solver 支持的倒角类型。 */
  public abstract readonly type: ChamferType;

  /**
   * 判断当前 solver 是否支持指定倒角类型。
   *
   * @param type 倒角类型。
   * @returns 是否支持。
   */
  public supports(type: ChamferType): boolean {
    return this.type === type;
  }

  /**
   * 构建倒角 Shape。
   *
   * @param input 倒角求解输入。
   * @returns 倒角结果 Shape。
   */
  public abstract build(input: ChamferShapeBuildInput): unknown;
}

